import { ImageUploadComponent } from 'angular2-image-upload';
import { Component } from '@angular/core';

@Component({
    selector: 'lls-image-upload',
    templateUrl: './lls-image-upload.component.html',
    styleUrls: [
        './lls-image-upload.component.scss'
    ]
})
export class LLSImageUploadComponent extends ImageUploadComponent {}